// extracted by mini-css-extract-plugin
export default {"list":"LiteralsWindow_list__E-tWp","symbol":"LiteralsWindow_symbol__P9FcS","activeSymbol":"LiteralsWindow_activeSymbol__kihQe","glare":"LiteralsWindow_glare__geEu-"};